import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { BaseComponent } from '@base/base.component';
import { CommissionEnum } from '@enums/commission';
import { CustomValidators } from '@forms/custom-validators';
import { DateHelper } from '@helpers/data-helper';
import { CommissionType } from '@models/reports/reports';
import { KeyValueOptions } from '@models/settings/settings';

@Component({
  selector: 'app-commissions-report-filter',
  templateUrl: './commissions-report-filter.component.html',
  styleUrl: './commissions-report-filter.component.scss'
})
export class CommissionsReportFilterComponent extends BaseComponent {
  @Input() commissionTypes: CommissionType[] = [];
  @Input() loading: boolean = false;
  @Output() filtersChanged = new EventEmitter<any>();
  @Output() search = new EventEmitter<void>();

  public form: FormGroup;
  startDateLabel: string = "";
  endDateLabel: string = "";
  public comissionType: CommissionType

  public dealerOptions: KeyValueOptions[] = [];

  private staticControls: string[] = ["commissionType", "startDate", "endDate", "searchTerm", "identifierCode"];

  get showSearchInput(): boolean {
    return this.comissionType?.filters?.some(item => item.key === "filterBy")
  }

  public constructor(private readonly _fb: FormBuilder
                  ) {
                    super();
                  }

  public ngOnInit() {
    this.createForm();
    this.listDealers();
    this.updateLabelsAndFields();
  }

  private createForm() {
    this.form = this._fb.group({
      commissionType: [CommissionEnum.PENDING_INVOICE, [Validators.required]],
      identifierCode: [0, [Validators.required]],
      startDate: [DateHelper.SubstractDaysFromDate(DateHelper.currentDateIgnoreTime, 30), [Validators.required]],
      endDate: [DateHelper.currentDateIgnoreTime, [Validators.required]],
      searchTerm: [null],
    });

    this.form.setValidators([
      CustomValidators.isStartDateGreaterThanEndDate("startDate", "endDate"),
      CustomValidators.shouldBeRequiredIfFieldIsNotNull("startDate", "endDate"),
      CustomValidators.shouldBeRequiredIfFieldIsNotNull("endDate", "startDate"),
    ]);
  }

  public cleanForm(): void {
    this.form.patchValue({
      commissionType: CommissionEnum.PENDING_INVOICE,
      startDate: DateHelper.SubstractDaysFromDate(DateHelper.currentDateIgnoreTime, 30),
      endDate: DateHelper.currentDateIgnoreTime,
      typeQuery:null,
      filterBy: null,
      searchTerm: ""
    });

    this.removeControls();
    this.updateLabelsAndFields();
  }

  public async listDealers() {
    const allowedDealersOptions = this.getAllAllowedDealersForCurrentHierachy().map<KeyValueOptions>(us => ({
      key: `${us.identifierCode} - ${us.description}`,
      value: us.identifierCode
    }));

    this.dealerOptions = [
      {
        key: "Todos",
        value: 0
      },
      ...allowedDealersOptions];
  }

  public updateLabelsAndFields(): void {
    var value = this.form.get('commissionType').value;
    this.comissionType = this.commissionTypes.find((type) => type.id === value)
    this.startDateLabel = this.comissionType.startDateLabel;
    this.endDateLabel = this.comissionType.endDateLabel;

    this.addControls()

    this.filtersChanged.emit(value);
  }

  enforceInteger(event: Event): void {
    const input = event.target as HTMLInputElement;
    input.value = input.value.replace(/\D+/g, '');
  }

  private addControls(): void {
    if(this.comissionType.filters?.length > 0){
      this.comissionType.filters.forEach(filter => {
        if(!this.form.get(filter.key)){
          this.form.addControl(filter.key, new FormControl(filter.options[0].key || []));
        } else {
          this.form.get(filter.key).setValue(filter.options[0].key);
        }
      })
    }

    this.form.updateValueAndValidity()
  }

  private removeControls(): void {
    Object.keys(this.form.controls).forEach(control => {
      if(!this.staticControls.includes(control)){
        this.form.removeControl(control)
      }
    })

    this.form.updateValueAndValidity()
  }

  public onSearch(): void {
    if (this.form.invalid || this.loading) {
      return;
    }

    const shouldFilterByTerm = this.form.value['filterType'] !== ' ';

    if (shouldFilterByTerm && this.form.value['searchTerm'] && this.isNumberGreaterThanInt32(Number.parseInt(this.form.value['searchTerm']))) {
      this.openErrorDialog('Erro de validação', 'O valor informado para consulta é inválido. Informe um número com até 9 dígitos.');
      return;
    }

    this.search.emit();
  }

  private isNumberGreaterThanInt32(number: number): boolean {
    if (Number.isNaN(number)) {
      return false;
    }
    return number > 2147483647;
  }
}
